import React from 'react'

const Workbanner = () => {
  return (
    <div className="mt-20 bg-sec1">
      <div className=" text-prime flex items-center justify-center font-semibold text-2xl font-[Montserrat] pt-20">Our Work</div>
      <div className="flex items-center justify-center text-center text-6xl font-[Montserrat] font-extrabold mt-20 mx-80 w-[1100px]">
        Scalable web and mobile app products
      </div>
      <div className="flex items-center justify-center text-center text-2xl font-[Montserrat] font-medium mt-10 pb-20">
        Check out how our clients are doing amazing things with the software.
      </div>
    </div>
  )
}

export default Workbanner
